__turbopack_context__.v({
  "className": "theseasons_2d185802-module__cPURQa__className",
  "variable": "theseasons_2d185802-module__cPURQa__variable",
});
